export default __webpack_public_path__ + "static/media/lexus.670fae5c.svg";